const cleanups = new Set<() => void>();

/**
 * A module that keeps per-member state outside the query cache (an unsent draft, say) hands
 * its reset here, so signing out forgets it too. The core does not import the modules.
 */
export function onSessionCleared(cleanup: () => void): void {
  cleanups.add(cleanup);
}

/** Signing out (or an expired session): runs every registered reset. */
export function clearSessionState(): void {
  for (const cleanup of cleanups) cleanup();
}
